import React, { useState } from "react";
import Button from "./Button";
import ProgressBar from "./ProgressBar";
import { useStateContext } from "../contexts/ContextProvider";
import { BsBank } from "react-icons/bs";
import { SiCashapp } from "react-icons/si";
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcDiscover,
  FaCcAmex,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const initialErrorState = {
  paymentType: "",
  paymentAmount: "",
  enterValue: "",
};

const PaymentsModal = (props) => {
  const { balance, leaseId } = props;
  const { handleModal, payment, setPayment } = useStateContext();
  const [page, setPage] = useState(1);
  const [error, setError] = useState(initialErrorState);
  const [checkbox, setCheckbox] = useState({
    creditCard: false,
    bankAch: false,
    totalAmount: false,
    customAmount: false,
  });

  const navigate = useNavigate();

  const pages = 3;

  // define credit card related fees - TODO: add to environmental variables.
  const stripeVariableFeePercent = 0.029; // 2.9%
  const inverseFeePercent = 1 - stripeVariableFeePercent;
  const stripeFixedFee = 0.3; // $0.30
  const snappilyFixedFee = 5; // $5.00
  const totalFixedFees = snappilyFixedFee + stripeFixedFee; // $5.30

  const nextPage = async () => {
    if (hasErrors()) {
      return;
    } else {
      calculateTotals();
      setPage(page + 1);
    }
  };

  const prevPage = () => {
    setPage(page - 1);
  };

  const handleCustomAmount = (event) => {
    const { name, value } = event.target;
    setPayment((prevState) => ({
      ...prevState,
      [name]: Number(value),
    }));
  };

  const handleCheckbox = (event) => {
    const { name, checked } = event.target;
    if (name === "totalAmount") {
      setCheckbox((prevState) => ({
        ...prevState,
        totalAmount: checked,
        customAmount: false,
      }));
      setPayment((prevState) => ({
        ...prevState,
        amount: balance,
        customAmount: 0,
      }));
    }
    if (name === "customAmount") {
      setCheckbox((prevState) => ({
        ...prevState,
        totalAmount: false,
        customAmount: checked,
      }));
      // setPayment((prevState) => ({
      //   ...prevState,
      //   amount: 0,
      // }));
    }
    if (name === "creditCard") {
      setCheckbox((prevState) => ({
        ...prevState,
        creditCard: checked,
        bankAch: false,
      }));
      setPayment((prevState) => ({
        ...prevState,
        isCreditCard: true,
      }));
    }
    if (name === "bankAch") {
      setCheckbox((prevState) => ({
        ...prevState,
        creditCard: false,
        bankAch: checked,
      }));
      setPayment((prevState) => ({
        ...prevState,
        fees: 0,
        isCreditCard: false,
      }));
    }
  };

  const handlePayment = () => {
    if (hasErrors()) {
      return;
    } else {
      handleModal("makePayment");
      navigate("/checkout");
    }
  };

  const calculateTotals = () => {
    if (checkbox.creditCard) {
      setPayment((prevState) => ({
        ...prevState,
        leaseId,
        amount: balance,
        fees: payment.customAmount
          ? Math.round(
              ((payment.customAmount + totalFixedFees) / inverseFeePercent -
                payment.customAmount) *
                100
            ) / 100
          : Math.round(
              ((payment.amount + totalFixedFees) / inverseFeePercent -
                payment.amount) *
                100
            ) / 100,
        totalAmount: payment.customAmount
          ? Math.round(
              ((payment.customAmount + totalFixedFees) / inverseFeePercent) *
                100
            ) / 100
          : Math.round(
              ((payment.amount + totalFixedFees) / inverseFeePercent) * 100
            ) / 100,
      }));
    } else {
      setPayment((prevState) => ({
        ...prevState,
        leaseId,
        amount: balance,
        totalAmount: payment.customAmount ? payment.customAmount : balance,
      }));
    }
  };

  console.log(payment, balance);

  //TODO: Show these errors!!!
  const hasErrors = () => {
    const reg = new RegExp("^[0-9]+(.[0-9]{1,2})?$"); // fixed to two decimal places?
    console.log(reg.test(payment.amount));
    if (page === 1 && !checkbox.bankAch && !checkbox.creditCard) {
      activateError("paymentType");
      return true;
    } else if (page === 2 && !checkbox.customAmount && !checkbox.totalAmount) {
      activateError("paymentAmount");
      return true;
    } else if (
      page === 2 &&
      (payment.amount < 0 || payment.customAmount > payment.amount)
    ) {
      activateError("paymentAmount");
      return true;
    } else if (
      page === 2 &&
      checkbox.customAmount &&
      (!reg.test(payment.customAmount) || !payment.customAmount)
    ) {
      activateError("enterValue");
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  return (
    <div className="w-screen fixed top-0 left-0 right-0 bottom-0 bg-white mt-20 z-10">
      <ProgressBar pages={pages} currentPage={page} />
      <div className="grid justify-items-center mt-10 h-1/2">
        {page === 1 && (
          <div className="mt-5">
            <div
              className={`flex justify-center text-2xl ${error.paymentType}`}
            >
              Select Payment Method:
              <span className="text-red-500">*</span>
            </div>
            <div className="mt-12">
              <div className="flex justify-center items-center">
                <input
                  id="bank-ach"
                  name="bankAch"
                  type="checkbox"
                  checked={checkbox.bankAch}
                  onChange={handleCheckbox}
                  className="h-5 w-5 rounded-full mr-5"
                />
                <div className="text-2xl">Bank Transfer (ACH)</div>
                <div className="pl-3 text-2xl">
                  <BsBank />
                </div>
              </div>
              <div className="pl-10">(FREE)</div>
            </div>
            <div className="flex items-start mt-5">
              <input
                id="credit-card"
                name="creditCard"
                type="checkbox"
                checked={checkbox.creditCard}
                onChange={handleCheckbox}
                className="h-5 w-5 rounded-full mt-2 mr-5"
              />
              <div>
                <div className="text-2xl">Credit Card / Cash App</div>
                <div className="flex gap-x-2 text-3xl">
                  <FaCcVisa />
                  <FaCcMastercard />
                  <FaCcDiscover />
                  <FaCcAmex />
                  <SiCashapp className="text-green-500" />
                </div>
                <div className="text-sm text-red-500">
                  (Additional Fees Apply)
                </div>
              </div>
            </div>
          </div>
        )}
        {page === 2 && (
          <div>
            <div
              className={`flex justify-center text-2xl text-justifieds mt-5 px-5 ${error.paymentAmount}`}
            >
              Select Payment Amount:
              <span className="text-red-500">*</span>
            </div>
            <div className="grid grid-cols-2 justify-items-center text-xl mt-20 px-10">
              <div className="flex place-self-start items-center">
                <input
                  id="total-amount"
                  name="totalAmount"
                  type="checkbox"
                  checked={checkbox.totalAmount}
                  onChange={handleCheckbox}
                  className="h-5 w-5 rounded-full mr-5"
                />
                <div className="">Total Due:</div>
              </div>
              <div>
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(balance)}
              </div>
            </div>
            <div className="grid grid-cols-2 justify-items-center text-xl mt-10 px-10">
              <div className="flex place-self-start items-center">
                <input
                  id="custom-amount"
                  name="customAmount"
                  type="checkbox"
                  checked={checkbox.customAmount}
                  onChange={handleCheckbox}
                  className="h-5 w-5 rounded-full mr-5"
                />
                <div className={`${error.enterValue}`}>Other:</div>
              </div>
              <div className="flex relative">
                <div
                  className={`absolute left-2 ${
                    checkbox.customAmount ? "text-black" : "text-gray-300"
                  } ${error.enterValue}`}
                >
                  $
                </div>
                <input
                  id="custom-amount"
                  name="customAmount"
                  type="number"
                  maxLength={7}
                  placeholder="$0.00"
                  disabled={!checkbox.customAmount}
                  value={payment.customAmount || ""}
                  className={`w-28 text-right border-gray-300 border-1 rounded-lg pr-1 ${error.enterValue}`}
                  onChange={handleCustomAmount}
                />
              </div>
            </div>
          </div>
        )}
        {page === 3 && (
          <div>
            <div className="flex justify-center text-3xl">Payment Summary:</div>
            <div className="grid grid-cols-2 gap-x-5 mt-10">
              <div>Type:</div>
              <div className="place-self-end">
                {checkbox.creditCard ? "Credit Card" : "Ach Bank Transfer"}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-x-5 mt-5">
              <div>Amount:</div>
              <div className="place-self-end">
                {payment.customAmount
                  ? Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(payment.customAmount)
                  : Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(payment.amount)}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-x-5 mt-5">
              <div>Fees:</div>
              <div className="place-self-end">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(payment.fees)}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-x-5 text-xl mt-10">
              <div>Total Payment:</div>
              <div className="place-self-end">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(payment.totalAmount)}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex justify-center w-full bg-white mt-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === 1 ? "Cancel" : "Back"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => {
            page === 1 ? handleModal("makePayment") : prevPage();
          }}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === pages ? "Pay" : "Next"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => {
            page === pages ? handlePayment() : nextPage();
          }}
        />
      </div>
    </div>
  );
};

export default PaymentsModal;
